import {
  buildContractValidationFormData,
  ContractValidationPayload,
} from 'services/actions/contract_validations';
import { ContractAnalysisTypes } from './types';

export const list_contract_analysis = (page: number, statusFilters: string[], search: string) => ({
  types: [
    ContractAnalysisTypes.GET_CONTRACT_ANALYSIS_REQUEST,
    ContractAnalysisTypes.GET_CONTRACT_ANALYSIS_SUCCESS,
    ContractAnalysisTypes.GET_CONTRACT_ANALYSIS_FAILURE,
  ],

  promise: (client: any) =>
    client.get('/contract_validations', {
      params: {
        page,
        status: statusFilters,
        search,
      },
    }),
});

export const detailed_contract = (id: string) => ({
  types: [
    ContractAnalysisTypes.DETAILED_CONTRACT_ANALYSIS_REQUEST,
    ContractAnalysisTypes.DETAILED_CONTRACT_ANALYSIS_SUCCESS,
    ContractAnalysisTypes.DETAILED_CONTRACT_ANALYSIS_FAILURE,
  ],

  promise: (client: any) => client.get(`/contract_validations/${id}`),
});

export const get_info_bidding = (bidding_id: number) => ({
  types: [
    ContractAnalysisTypes.GET_INFO_BIDDING_REQUEST,
    ContractAnalysisTypes.GET_INFO_BIDDING_SUCCESS,
    ContractAnalysisTypes.GET_INFO_BIDDING_FAILURE,
  ],

  promise: (client: any) =>
    client.get('/contract_validations/get_info_bidding', { params: { bidding_id } }),
});

export const validate_contract = (payload: ContractValidationPayload) => ({
  types: [
    ContractAnalysisTypes.VALIDATE_CONTRACT_REQUEST,
    ContractAnalysisTypes.VALIDATE_CONTRACT_SUCCESS,
    ContractAnalysisTypes.VALIDATE_CONTRACT_FAILURE,
  ],

  promise: (client: any) =>
    client.post('/contract_validations', buildContractValidationFormData(payload)),
});
